<div class="dashboard-container">
  <div class="header">
    <!-- <div class="header-content">
      <h1>Engineering Tool Hub</h1>
      <p class="subtitle">Access and manage all your engineering tools</p>
    </div> -->

    <div class="filters-section">
      <div class="search-box">
        <input
          type="text"
          placeholder="Search tools..."
          [(ngModel)]="search"
          (input)="onSearchChange()"
          class="search-input"
        >
        <span class="search-icon">🔍</span>
      </div>

      <div class="category-filters">
        <button
          *ngFor="let category of categories"
          [class.active]="selectedCategory === category"
          (click)="selectedCategory = category; onCategoryChange()"
          class="category-btn"
        >
          {{ category === 'all' ? 'All Tools' : category }}
        </button>
      </div>
    </div>
  </div>

  <div class="content-section">
    <div *ngIf="loadError" class="tools-count">
      <span>{{ loadError }}</span>
    </div>

    <ng-container *ngIf="loading; else loadedContent">
      <div class="loading-state">
        <div class="spinner"></div>
        <p>Loading tools...</p>
      </div>
    </ng-container>

    <ng-template #loadedContent>
      <div class="tools-count">
        <span>{{ filteredTools.length }} tool{{ filteredTools.length !== 1 ? 's' : '' }} found</span>
      </div>

      <div *ngIf="filteredTools.length > 0; else noTools" class="cards-grid">
        <app-tool-card
          *ngFor="let tool of filteredTools"
          [tool]="tool"
          class="card-item"
        ></app-tool-card>
      </div>

      <ng-template #noTools>
        <div class="no-tools">
          <div class="empty-state">
            <p class="empty-icon">🔧</p>
            <h2>No tools found</h2>
            <p>Try adjusting your search or filter criteria</p>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
